import { MuWidget } from "mu-widget/lib/MuWidget";


export class UiFlashContainer extends MuWidget
{
	public static instance: UiFlashContainer;

	public afterIndex()
	{
		this.updateVisibility();
		UiFlashContainer.instance = this;
	}

	public updateVisibility() 
	{
		this.container.style.display = this.ui.items.firstElementChild
			? null
			: "none";
	}

	public add(text : string, template : string = 'item') : UiFlashItem
	{
		var item = this.muWidgetFromTemplate(template, "items", { text: text }) as UiFlashItem;
		this.updateVisibility();
		return item;
	}

    public static add(text : string, template : string|"loader"|"flash" = 'flash') : UiFlashItem
    {
        return UiFlashContainer.instance.add(text, template);
    }

    beforeIndex(): void {
        this.container.classList.add('flash-message__container');
        this.muAppendContent(/*html*/`<div mu-id="items"></div>
				<div mu-widget="UiFlashItem" mu-template="loader" class="flash-message__loader"><span mu-id="text"></span></div>
				<div mu-widget="UiFlashItem" mu-template="flash" class="flash-message__flash">
					<span class="flash-message__flash__head">
						<span class="flash-message__flash__text" mu-id="text"></span>
						<span class="flash-message__flash__close" mu-id="bClose">&times;</span>
					</span>
					<div class="flash-message__flash__close" mu-id="extraContent"></div>
				</div>
			</div>
        `);
    }
}

export class UiFlashItem extends MuWidget
{
	public text : string;

	public showDuration: number|null = 7000; // 7000;

	public afterIndex()
	{
		this.ui.text.innerText = this.text;
		const animationDuration = 300;
		if (this.showDuration) {
			setTimeout(() => this.container.style.animation = "flash-remove " + animationDuration.toString() + "ms ease-in both", this.showDuration); // .toggleAttribute('loader-item__removing'), this.showDuration);
			setTimeout(() => this.muRemoveSelf(), this.showDuration + animationDuration);
		}
	}

	public remove() : void
	{
		this.muRemoveSelf();
		(this.muParent as unknown as UiFlashContainer).updateVisibility();
	}

	public bClose_click() : void
	{
		this.remove();
	}

	public setMessage(message: string) {
		this.ui.text.innerText = this.text = message;
	}

}
